<div class="wrap-hero">
  <app-header></app-header>
  <app-hero></app-hero>
</div>

<!-- <app-destacado></app-destacado> -->
<!-- <app-carrusel-vehiculos></app-carrusel-vehiculos> -->
<!-- <app-coches-destacado></app-coches-destacado> -->
<!-- <app-coches-servicios> </app-coches-servicios> -->
<!-- <app-servicios-destacados> </app-servicios-destacados> -->

<!-- <app-pre-contacto></app-pre-contacto> -->

<!-- <app-faqs></app-faqs> -->

<section>
  <app-product-list></app-product-list>
</section>

<!-- <app-mapa></app-mapa> -->
<!-- <app-opiniones></app-opiniones> -->

<app-footer></app-footer>
